// extracted by css-extract-rspack-plugin
export default {"container":"DC8YpFFfAbgQGShe","emptyStateTitle":"aR5jVDAa9dYJj1WU","text":"aG9ym50PhjICv6Ia","link":"_LtCEEGhCi4r7xsv"};